import { all } from 'redux-saga/effects'
// import pickLocation from "./pickLocation/saga"

export default function* commonSaga() {
    yield all([
        // pickLocation(),
    ]);
}